import 'rxjs/Rx';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Rx';
import { Http } from '@angular/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Alert } from '../models/alert';
import {ApiService} from './api.service';

@Injectable()
export class AlertService {

    casesLink = environment.alertsLink;

    apiService: ApiService = new ApiService(this.http);

    constructor(
      private http: Http
    ) { }

    getAlertsByUserId(org: string, userId: string){
      // return this.apiService.getCall('alertsLink' , `organization/${org}/user/${userId}/alerts`);
      return this.apiService.getCall('alertsLink' , `user/${userId}/alerts`);
    }

    getAlertsByOrgId(orgId: string){
      return this.apiService.getCall('alertsLink' , `organization/${orgId}/alerts`);
    }

    postAlert(caseId: string, alertForm: any){
      return this.apiService.postCall('alertsLink' , `cases/${caseId}/alert`,alertForm);
    }

    putAlert(caseId: string, userId: string, alertId: string, alertData: string){
      return this.apiService.putCall('alertsLink' ,  `cases/${caseId}/${userId}/${alertId}`, alertData);
    }

    alertViewed(orgId: string, caseId: string, alertId: string, data: any){
      return this.apiService.putCall( 'alertsLink' , `organization/${orgId}/cases/${caseId}/${alertId}/viewed`, data);
    }

    closeAlert(orgId: string, caseId: string, alertId: string, data: any){
      return this.apiService.putCall('alertsLink' ,  `organization/${orgId}/cases/${caseId}/${alertId}/close`, data);
    }

    postComment(caseId: string, alertId: string, data: any){
      return this.apiService.postCall('alertsLink' , `cases/${caseId}/${alertId}/comments`,data);
    }
}



// WEBPACK FOOTER //
// ./src/app/main/shared/services/alert.service.ts